import { render, staticRenderFns } from "./Orderareals.vue?vue&type=template&id=1a62c257&scoped=true"
import script from "./Orderareals.vue?vue&type=script&lang=js"
export * from "./Orderareals.vue?vue&type=script&lang=js"
import style0 from "./Orderareals.vue?vue&type=style&index=0&id=1a62c257&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a62c257",
  null
  
)

export default component.exports